import { Component, OnInit } from '@angular/core';
import { ServiceService } from 'src/app/services/service.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  userForm: FormGroup;
  userdetails: any[] = [];
  getvalue: any;
  city: any;
  streetAddress: any;
  addressOnly: any;
  user_id: any;
  api_version: any;
  client_id: any;
  nas_id: any;
  ps_key: any;
  profile_image: any;
  constructor(private services: ServiceService, private http: HttpClient, public location: Location) {
  }

  ngOnInit(): void {

    this.user_id = localStorage.getItem('user_name');
    this.api_version = localStorage.getItem('api_version');
    this.client_id = localStorage.getItem('client_id');
    this.nas_id = localStorage.getItem('nas_id');
    this.ps_key = localStorage.getItem('ps_key');
    this.profile_image = localStorage.getItem('profile_image');
    // this.userForm=this.fb.group({
    //   user_id: [''],
    //   first_name: [''],
    //   last_name: [''],
    //   email: [''],
    //   mobile: [''],
    //   phone: [''],
    //   address: [''],
    //   gstin_no: [''],
    //   pri_bw_plan_name: [''],
    //   ext_bw_plan_name: ['']
    // });
    this.postData();
  }

  postData() {
    const body = new HttpParams()
      // .set('api_version', this.api_version)
      // .set('client_id', this.client_id)
      // .set('ps_key', this.ps_key)
      // .set('nas_id', this.nas_id)
      .set('action_id', 'get_user_record')
      .set("action", "get_url")
      .set('req_params', JSON.stringify({ req_id: 'string', user_id: this.user_id }));

    // Set headers
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    this.services.sendServer2(body.toString(), headers).subscribe(
      (response: any) => {
        //  console.log('API Response:', response);

        if (response && response.results) {

          this.userdetails = Array.isArray(response.results) ? response.results : [response.results];
          //  console.log(this.userdetails);

          this.extractAddressCity(response.results.address);
        } else {
          console.error('Results not found in response:', response);

        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }


  extractAddressCity(address: string) {
    let parts = address.split(",");

    if (parts.length >= 2) {

      this.city = parts[parts.length - 1];
      //console.log("length:", parts.length);
      this.addressOnly = address.replace(',' + parts[parts.length - 1], "")

    }
    else {
      this.addressOnly = address;
      this.city = "Unknown";
    }
    // console.log("Address:", this.addressOnly);
    // console.log("City:", this.city);
  }

  cancel() {

    this.location.back();
  }


  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.profile_image = reader.result as string; // Show preview
        // Optionally, upload to backend here
        this.uploadProfileImage(file);
      };
      reader.readAsDataURL(file);
    }
  }


  uploadProfileImage(file: File) {
    var data: any = new FormData();
    data.append("file", file);
    data.append("action", "update_profile");
    data.append("phone_number", this.user_id);

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {

        if (result.success == true || result.success == "true") {
          self.services.setProfileImage(result.data.profile_image);
          localStorage.setItem('profile_image', result.data.profile_image);
          // window.location.reload()
        } else {
        }
      }
    });
  }


}
